import React from 'react';
import { splitNameKeywords } from '@this/domain/hotel/hotel_name_filter';

const escapeRegExp = (str: string): string => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

type Props = {
  text: string;
  keyword: string;
};

export const HotelNameHighlight: React.FC<Props> = ({ text, keyword }) => {
  const keywords = splitNameKeywords(keyword);
  // 「ホテル ホテルニュー」のように包含関係がある場合に長い語を優先一致させる
  const uniqueKeywords = Array.from(new Set(keywords.map(k => k.toLowerCase()))).sort(
    (a, b) => b.length - a.length
  );
  const parts =
    uniqueKeywords.length === 0
      ? [text]
      : text.split(new RegExp(`(${uniqueKeywords.map(escapeRegExp).join('|')})`, 'ig'));

  return (
    <>
      {parts.map((part, i) =>
        uniqueKeywords.includes(part.toLowerCase()) ? (
          // eslint-disable-next-line react/no-array-index-key
          <mark key={i} style={{ backgroundColor: '#fff3a0', color: 'inherit', padding: 0 }}>
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </>
  );
};
